import { render, staticRenderFns } from "./AddVideoView.vue?vue&type=template&id=68078a0e&scoped=true&"
import script from "./AddVideoView.vue?vue&type=script&lang=js&"
export * from "./AddVideoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68078a0e",
  null
  
)

export default component.exports